<template>
  <div class="batchAcount">
    <div class="goods_acount">
      <div>
        <span>商品金额共</span>
        <span>{{batchTotal.amount*1}}</span>
        <span>元</span>
        <span>
          （其中
          <span v-if="batchTotal.discount<=0">订单优惠{{Math.abs(batchTotal.discount)}}元</span>
          <span v-if="batchTotal.discount>0">订单多收{{batchTotal.discount*1}}元</span>，不含附加费）
        </span>
        <span>，{{batchTotal.order_count}}单</span>
        <span>，{{batchTotal.totalCount}}个批次</span>
      </div>
      <div class="time">
        <Calendar v-model="data_picker" @change="changeTime"></Calendar>
      </div>
    </div>
    <div class="list_box" v-if="batchList.length>0">
      <div class="list_tl">
        <span>序号</span>
        <!-- <span>入库时间</span> -->
        <span>批次号</span>
        <!-- <span>货主</span> -->
        <span>类型</span>
        <span>单数</span>
        <span>货款</span>
        <span>销售额</span>
        <span>状态</span>
        <span></span>
      </div>
      <div class="list_content">
        <md-scroll-view
          ref="scrollView"
          :auto-reflow="false"
          :bouncing="true"
          :scrolling-x="false"
          @end-reached="$_onEndReached"
        >
          <div
            class="list"
            v-for="(item,index) in batchList"
            :key="index"
            @click="goDetail(item.order_count,item.goods_batch_id,item.supplier_name)"
          >
            <span>{{index+1}}</span>
            <!-- <span>{{item.created_at|toTime}}</span> -->
            <!-- <span>{{item.batch_no}}</span> -->
            <span>
              <span>{{item.supplier_name}}</span>
              <span>{{item.batch_no | addZero}}</span>
            </span>
            <!-- <span>{{item.supplier_name}}</span> -->
            <span>
              <span v-if="item.type==1" style="background:#CCEEFF;color:#00A8FF">自营</span>
              <span v-if="item.type==2" style="background:#FDE1CC;color:#F76900">代卖</span>
            </span>
            <span>{{item.order_count}}单</span>
            <span>{{item.batch_amount*1}}元</span>
            <span>{{item.amount*1}}元</span>
            <span>
              <span v-if="item.is_sale==1" style="color:#31b158">在售</span>
              <span v-if="item.is_sale==0" style="color:#fa4a5e">售罄</span>
            </span>
            <span>
              <md-icon name="arrow-right" size="sm" v-if="item.order_count>0"></md-icon>
            </span>
          </div>
          <md-scroll-view-more
            :finished-text="batchList.length>0?'全部已加载':'暂无数据'"
            slot="more"
            :is-finished="isFinished"
          ></md-scroll-view-more>
        </md-scroll-view>
      </div>
    </div>
    <div v-if="batchList.length==0" style="text-align:center;color:#999;line-height:0.8rem">暂无数据~</div>
  </div>
</template>
<script>
import { Batch_Acount } from "@/api/work/acount/salesAcount";
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import Calendar from "@/components/Calendar";
export default {
  name: "batchAcount",
  components: {
    Calendar,
  },
  filters: {
    toDate(t) {
      return timestampToDate(t);
    },
    toTime(t) {
      return timestampToTime(t);
    },
  },
  data() {
    return {
      batchQuery: {
        //接口传参
        s: "",
        e: "",
        page: 1,
        pagesize: 55,
      },
      batchList: [], //
      batchTotal: {
        amount: "",
        discount: "",
        order_count: "",
        totalCount: "",
      },
      data_picker: [],
      isFinished: false,
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    getList() {
      if (this.batchQuery.page == 1) {
        this.batchList = [];
      }
      Batch_Acount(this.batchQuery).then((res) => {
        if (res.code == 200) {
          this.batchTotal.amount = res.data.amount || 0;
          this.batchTotal.discount = res.data.discount || 0;
          this.batchTotal.discount = res.data.discount || 0;
          this.batchTotal.order_count = res.data.order_count || 0;
          this.batchTotal.totalCount = res.data.totalCount || 0;
          this.batchList = this.batchList.concat(res.data.list);
          if (
            (this.batchList && this.batchList.length == res.data.totalCount) ||
            res.data.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.batchQuery.page++;
          }
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    //选择时间
    changeTime(e) {
      if (this.data_picker) {
        this.batchQuery.s = timestampToDate(this.data_picker[0]);
        this.batchQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.batchQuery.s = "";
        this.batchQuery.e = "";
      }
      this.batchQuery.page = 1;
      this.batchList = [];
      this.getList();
    },
    goDetail(order_count, goods_batch_id, supplier_name) {
      if (order_count > 0) {
        this.$router.push({
          path: "/data/batchAcountDetail",
          query: { goods_batch_id, supplier_name,s:this.batchQuery.s,e:this.batchQuery.e },
        });
      }
      // else{
      //   this.$toast.failed('新批次,暂无详情数据')
      // }
    },
  },
};
</script>
<style lang="less" scoped>
.batchAcount {
  height: 100%;
  .goods_acount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0.22rem;
    padding-bottom: 0.12rem;
    border-bottom: 0.01rem solid #e5e5e5;
    height: 0.6rem;
    > div:nth-of-type(1) {
      font-size: 0.22rem;
      color: #404040;
      > span:nth-of-type(2) {
        color: #31b158;
      }
      > span:nth-of-type(4) {
        color: #999999;
        font-size: 0.2rem;
      }
    }
  }
  .list_box {
    height: calc(100% - 0.6rem);
    margin: 0 0.22rem;
    .list_tl {
      height: 0.68rem;
      border-bottom: 0.01rem solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > span {
        color: #555;
        font-size: 0.22rem;
        font-weight: bold;
      }
      > span:nth-of-type(1) {
        width: 0.6rem;
        text-align: left;
      }
      > span:nth-of-type(2) {
        width: 2.4rem;
        text-align: center;
      }
      > span:nth-of-type(3) {
        width: 0.6rem;
        text-align: center;
      }
      > span:nth-of-type(4) {
        width: 1rem;
        text-align: center;
      }
      > span:nth-of-type(5) {
        width: 2.4rem;
        text-align: center;
      }
      > span:nth-of-type(6) {
        width: 2.4rem;
        text-align: center;
      }
      > span:nth-of-type(7) {
        width: 0.6rem;
        text-align: center;
      }
      > span:nth-of-type(8) {
        width: 0.4rem;
        text-align: right;
      }
      // > span:nth-of-type(9) {
      //   width: 0.4rem;
      //   text-align: right;
      // }
    }
    .list_content {
      height: calc(100% - 0.68rem);
      font-size: 0.18rem;
      .list {
        height: 0.6rem;
        border-bottom: 0.01rem solid #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > span {
          color: #666;
          text-align: center;
        }
        > span:nth-of-type(1) {
          width: 0.6rem;
          text-align: left;
        }
        > span:nth-of-type(2) {
          width: 2.2rem;
          line-height: 0.24rem;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          > span:nth-of-type(1) {
            max-width: 1.8rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin-right: 0.04rem;
          }
          >span:nth-of-type(2){
            max-width: 0.6rem;
             text-overflow: ellipsis;
            overflow: hidden;
            line-height: 0.24rem;
            white-space: nowrap;
          }
        }
        > span:nth-of-type(3) {
          width: 0.6rem;
          text-align: center;
          >span{
            display: inline-block;
            width: 0.56rem;
            text-align: center;
            border-radius: 0.12rem;
            line-height: 0.24rem;
            font-size: 0.18rem;
          }
        }
        > span:nth-of-type(4) {
          width: 1rem;
          text-align: center;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          > span {
            padding: 0 0.1rem;
            height: 0.24rem;
            font-size: 0.18rem;
            line-height: 0.24rem;
            border-radius: 0.12rem;
          }
        }
        > span:nth-of-type(5) {
          width: 2.4rem;
          text-align: center;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        > span:nth-of-type(6) {
          width: 2.4rem;
          text-align: center;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        > span:nth-of-type(7) {
          width: 0.6rem;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        > span:nth-of-type(8) {
          width: 0.4rem;
          text-align: right;
          > span {
            padding: 0 0.1rem;
            font-size: 0.18rem;
            line-height: 0.24rem;
            border-radius: 0.12rem;
          }
        }
        // > span:nth-of-type(9) {
        //   width: 0.4rem;
        //   text-align: right;
        //   font-weight: bold;
        // }
      }
    }
  }
}
</style>
<style lang="less">
.time {
  .calendar_select_box {
    width: 2.6rem !important;
    border: 0.01rem solid #e5e5e5 !important;
    background: #fff !important;
  }
}
</style>